import {
    createApp
} from 'vue'
import './style.css'
import './scss/common.scss'
import './scss/other.scss'
import App from './App.vue'
// 引入rem适配
import './utils/rem.js'
// 引入路由配置
import router from './router'
// 引入vant组件库
import Vant from 'vant'
import 'vant/lib/index.css'
import 'vant/es/toast/style';

// 引入axios配置
import axios from './utils/axios.js'

// 引入pinia状态管理
import { createPinia } from 'pinia'
// 引入pinia持久化插件
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)
// 使用路由
app.use(router)
// 使用vant组件库
app.use(Vant)
// 使用pinia状态管理
app.use(pinia)
// 将axios挂载到Vue实例
app.config.globalProperties.$axios = axios
app.mount('#app')